import { FormikProps } from 'formik';
import React from 'react';

import { Template } from '../../../../../types/Template';
import AppStore from './appStore/AppStore';

export default function AppsPreview(props: FormikProps<Template>): JSX.Element {
  return <AppStore {...props} />;
}
